import React, { useState } from "react";
import {
  FormGroup,
  Label,
  Alert,
  Button
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ModalConfirm from "../components/modalConfirm";
import { useTranslation } from "react-i18next";

const PasswordForm = ({data}) => {
  const { t } = useTranslation();
  const Schema = Yup.object().shape({
    password: Yup.string().required(t("profile.set_new_password.form.validation.oldPasswordRequired")),
    newpassword: Yup.string().min(10, t("profile.set_new_password.form.validation.newPasswordMin")).required(t("profile.set_new_password.form.validation.newPasswordRequired")),
    passwordConfirmation: Yup.string().oneOf([Yup.ref('newpassword'), null], t("profile.set_new_password.form.validation.passwordsMustMatch"))
  });

  const [success, setSuccess] = useState(false);
  const [errorPut, setErrorPut] = useState(false);

  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  return (
    <>
      <Formik
        initialValues={{password:'', newpassword: '', passwordConfirmation: '',}}
        validationSchema={Schema}
        onSubmit={({password, newpassword, passwordConfirmation},{ setStatus, setSubmitting }) => {
          setStatus();
          setToggleModal(true);
          setDataModal({
            old_password: password,
            new_password: newpassword
          });
        }}
        render={({ errors, status, touched, isSubmitting, setFieldValue }) => {
          return (
            <Form>
              <FormGroup>
                <Label>{t("profile.set_new_password.form.label.currentPassword")}</Label>
                <Field
                  name="password"
                  type="password"
                  className={
                    "form-control" +
                    (errors.password && touched.password ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="invalid-feedback"
                />
              </FormGroup>
              <FormGroup>
                <Label>{t("profile.set_new_password.form.label.newPassword")}</Label>
                <Field
                  name="newpassword"
                  type="password"
                  className={
                    "form-control" +
                    (errors.newpassword && touched.newpassword ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="newpassword"
                  component="div"
                  className="invalid-feedback"
                />
              </FormGroup>
              <FormGroup>
                <Label>{t("profile.set_new_password.form.label.repeatNewPassword")}</Label>
                <Field
                  name="passwordConfirmation"
                  type="password"
                  className={
                    "form-control" +
                    (errors.repassword && touched.passwordConfirmation ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="repassword"
                  component="div"
                  className="invalid-feedback"
                />
              </FormGroup>

              <Button type="submit" color="success">
                {t("profile.set_new_password.form.button.submit")}
              </Button>
            </Form>
          );
        }}
      />
      <div style={{paddingTop: 20}}>
      {success && <Alert color="success">{t("profile.set_new_password.message.success")}</Alert>}
      {errorPut && <Alert color="danger">{t("profile.set_new_password.message.error")}</Alert>}
      </div>
      {openModal && (
        <ModalConfirm
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          title={t("profile.set_new_password.modal.header")}
          setSuccess={setSuccess}
          setError={setErrorPut}
          method={"POST"}
          body={t("profile.set_new_password.modal.body")}
          apiURL={`users/${data.id}/change-password`}
          setRedirect={false}
        />
      )}
    </>
  );
};

export default PasswordForm;
